// extracted by mini-css-extract-plugin
module.exports = {"notification":"Notification-notification-2Fkdc Card-card-1iGZk","name":"Notification-name-2sRQt","enabled":"Notification-enabled-RkjDT"};